import React from 'react';
import { useNavigate } from 'react-router-dom';

const DEALS = [
  { from: 'DEL', to: 'BOM', fromCity: 'Delhi', toCity: 'Mumbai',      price: 2499,  saving: 40, tag: '🔥 Hot Deal',   seats: 4, gradient: 'from-violet-600 to-purple-700' },
  { from: 'BLR', to: 'DEL', fromCity: 'Bangalore', toCity: 'Delhi',   price: 3199,  saving: 35, tag: '⚡ Flash Sale', seats: 7, gradient: 'from-amber-500 to-orange-600'   },
  { from: 'BOM', to: 'GOI', fromCity: 'Mumbai', toCity: 'Goa',        price: 1899,  saving: 50, tag: '🏖️ Weekend',   seats: 2, gradient: 'from-purple-600 to-violet-800'  },
  { from: 'DEL', to: 'CCU', fromCity: 'Delhi', toCity: 'Kolkata',     price: 2799,  saving: 30, tag: '💰 Best Price', seats: 9, gradient: 'from-violet-700 to-indigo-700'  },
  { from: 'HYD', to: 'BOM', fromCity: 'Hyderabad', toCity: 'Mumbai',  price: 2199,  saving: 45, tag: '🔥 Hot Deal',   seats: 3, gradient: 'from-amber-600 to-yellow-500'   },
  { from: 'MAA', to: 'DEL', fromCity: 'Chennai', toCity: 'Delhi',     price: 3499,  saving: 28, tag: '⚡ Flash Sale', seats: 6, gradient: 'from-purple-700 to-violet-600'  },
];

export default function FlashDeals() {
  const navigate = useNavigate();

  const today = new Date();
  const dateStr = today.toISOString().split('T')[0];

  return (
    <section className="py-12 sm:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-3">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="text-2xl">🔥</span>
              <span className="text-xs font-bold text-amber-600 uppercase tracking-widest bg-amber-100 px-3 py-1 rounded-full">Limited Time Offers</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-gray-900">Today's Flash Deals</h2>
            <p className="text-gray-500 text-sm mt-1">Fares updated live — grab them before they're gone</p>
          </div>
          <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-4 py-2 shadow-sm">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <span className="text-xs font-semibold text-gray-600">Live Prices</span>
          </div>
        </div>

        {/* Deal cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {DEALS.map((deal) => (
            <div
              key={`${deal.from}-${deal.to}`}
              onClick={() => navigate(`/flights?origin=${deal.from}&destination=${deal.to}&date=${dateStr}&adults=1&tripType=oneway&class=economy&passengers=1`)}
              className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              {/* Top gradient bar */}
              <div className={`bg-gradient-to-r ${deal.gradient} p-4 sm:p-5 text-white`}>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-bold bg-white/20 backdrop-blur-sm px-2.5 py-1 rounded-full">{deal.tag}</span>
                  <span className="text-xs font-semibold bg-red-500 px-2.5 py-1 rounded-full">
                    {deal.seats <= 3 ? `🚨 Only ${deal.seats} left` : `${deal.seats} seats`}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-center">
                    <p className="text-2xl font-black">{deal.from}</p>
                    <p className="text-white/70 text-xs">{deal.fromCity}</p>
                  </div>
                  <div className="flex-1 flex flex-col items-center gap-1 px-3">
                    <div className="w-full flex items-center gap-1">
                      <div className="h-px flex-1 bg-white/40" />
                      <span className="text-base">✈</span>
                      <div className="h-px flex-1 bg-white/40" />
                    </div>
                    <span className="text-white/60 text-xs">One Way</span>
                  </div>
                  <div className="text-center">
                    <p className="text-2xl font-black">{deal.to}</p>
                    <p className="text-white/70 text-xs">{deal.toCity}</p>
                  </div>
                </div>
              </div>

              {/* Bottom price row */}
              <div className="p-4 flex items-center justify-between">
                <div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-2xl font-black text-gray-900">₹{deal.price.toLocaleString('en-IN')}</span>
                    <span className="text-xs text-gray-400 line-through">₹{Math.round(deal.price / (1 - deal.saving / 100)).toLocaleString('en-IN')}</span>
                  </div>
                  <span className="text-xs font-bold text-green-600">Save {deal.saving}% today</span>
                </div>
                <button className="bg-gradient-to-r from-violet-700 to-amber-500 text-white text-xs font-bold px-4 py-2 rounded-xl group-hover:shadow-lg group-hover:shadow-violet-500/20 transition-all">
                  Book Now →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
